import { render, staticRenderFns } from "./AutoSaveDocEditor.vue?vue&type=template&id=7f7ee200&"
import script from "./AutoSaveDocEditor.vue?vue&type=script&lang=ts&"
export * from "./AutoSaveDocEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports